import { FormPanelKey } from '@tencent/chart-drawer-components/lib/schema';
import i18n from '@i18next/i18n';
import { isLineShape } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-elements/base';
import { ChartComponentPanelMapping } from '../constants';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { IAxisProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/axis/axis.interface';
import { isMarkerAvailableLine } from '@src/slide/domain/ui-model/element-modeles/property/chart/util/geometry';
import { ChartElementType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';

export function getChartElementFormKey(model: IChartModel, showMarker?) {
    const { selectedElement } = model;
    if (!selectedElement) {
        return FormPanelKey.CHART;
    }
    let selectedChartComponentType = selectedElement.type;
    if (selectedChartComponentType === ChartElementType.AXIS_LABEL) {
        const axis = model.getSelectedElementProperty() as IAxisProperty;
        const axisType = axis?.type;
        selectedChartComponentType = axisType === 'value' ? ChartElementType.VALUE_AXIS_LABEL : ChartElementType.NOT_VALUE_AXIS_LABEL;
    } else if (selectedChartComponentType === ChartElementType.GEOMETRY) {
        let panelName;
        let element;
        if ('group' in selectedElement) {
            element = selectedElement.group[0];
            panelName = i18n.t('数据系列格式');
        } else {
            element = selectedElement;
            panelName = i18n.t('数据点格式');
        }
        const geometryType = element.shapeType;
        const { specialGeometryType } = element.extra;
        if (isLineShape(geometryType)) {
            if (!isMarkerAvailableLine(geometryType, specialGeometryType)) return FormPanelKey.CHART_LINE_GEOMETRY;
            return showMarker
                ? FormPanelKey.CHART_LINE_WITH_MARKER_MARKER_PAGE
                : FormPanelKey.CHART_LINE_WITH_MARKER_LINE_PAGE;
        }
        return FormPanelKey.CHART_PLANE_GEOMETRY;
    }
    const panelKey = ChartComponentPanelMapping[selectedChartComponentType];
    return panelKey;
}
